// extracted by mini-css-extract-plugin
export default {"wrapper":"InfoPopup_wrapper__K2t94","popup":"InfoPopup_popup__Ftni-","text":"InfoPopup_text__ylgy5","btn":"InfoPopup_btn__72kiE","red":"InfoPopup_red__A1yE+"};